module.exports = __webpack_public_path__ + "static/media/yardnapha-consumed.beb5b146.mp3";